import { AnalyticsApi } from '@calm/evexia-web-sdk/generated/lib/api/analytics-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `AnalyticsApi`
 * @param accessToken
 * @returns
 */
export default function createAnalyticsApi(accessToken: () => Promise<string>) {
    return createApi(AnalyticsApi, accessToken);
}
